import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

// Fetch monthly leads report
export const getMonthlyLeadsReport = async (month, year) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dashboard/api/lead-report/monthly_leads_report/?month=${month}&year=${year}`,
      getHeaders()
    );
    return response.data; // Return the API response
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch monthly leads report"
    );
  }
};
